import React from 'react';
import * as classes from './content.module.css';
import getDate from '../../../../utils/getDate';
import getReadingTime from '../../../../utils/getReadingTime';

export default function Content({ blog }) {
  let blogDate = getDate(blog.date);

  return (
    <div className={classes.content}>
      <div className={classes.padding_zero}>
        <div
          className={`text_font_family ${classes.blog_date} ${classes.blog_date_padding}`}
        >
          <span style={{ fontWeight: 'bold' }}>
            {blog.author?.node.name || ''}
          </span>
          {` | ${blogDate} | `}
          <span>{getReadingTime(blog.content)}</span>
        </div>
        <div
          className={`text_font_family ${classes.blog_title} ${classes.content_space}`}
        >
          {blog.title}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: blog.content }}
          className={`$text_font_family ${classes.blog_description} ${classes.content_space}`}
        />
      </div>
    </div>
  );
}
